import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { FooterContext } from "@insite/content-library/Pages/Footer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    logoGridItem?: GridItemProps;
    linkList1GridItem?: GridItemProps;
    linkList2GridItem?: GridItemProps;
    linkList3GridItem?: GridItemProps;
    linkList4GridItem?: GridItemProps;
    subscribeGridItem?: GridItemProps;
    logoWrapper?: InjectableCss;
}

export const footerContainerStyles: FooterContainerStyles = {
    logoGridItem: {
        width: 12,
        css: css`
            width: 100%;
            display: flex;
            justify-content: center;
            img {
                height: 78px;
            }
        `,
    },
    linkList1GridItem: {
        width: [12, 12, 6, 3, 3],
        css: css`
            padding: 0;
        `,
    },
    linkList2GridItem: {
        width: [12, 12, 6, 3, 3],
        css: css`
            padding: 0;
        `,
    },
    linkList3GridItem: {
        width: [12, 12, 6, 3, 3],
        css: css`
            padding: 0;
        `,
    },
    subscribeGridItem: {
        width: [12, 12, 6, 3, 3],
        css: css`
            padding: 0;
            ${({ theme }: { theme: BaseTheme }) => {
                return breakpointMediaQueries(theme, [
                    null,
                    css`
                        margin: auto;
                    `,
                    css`
                        margin-left: auto !important;
                    `,
                    null,
                    null,
                ]);
            }}
        `,
    },
    logoWrapper: {
        css: css`
            width: 110px;
        `,
    },
    widgetGridContainer: {
        css: css`
            margin: auto;
            background-color: transparent;

            ${({ theme }: { theme: BaseTheme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        background-color: #000;
                    `,
                    null,
                    null,
                    css`
                        background-color: transparent;
                        padding-top: 20px;
                    `,
                    css`
                        background-color: transparent;
                        padding-top: 20px;
                    `,
                ]);
            }}
        `,
    },
};

const FooterContainer: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));

    return (
        <>
            <GridContainer gap={0} {...styles.widgetGridContainer}>
                <GridItem {...styles.linkList1GridItem}>
                    <Zone zoneName="LinkList1" contentId={id} />
                </GridItem>
                <GridItem {...styles.linkList2GridItem}>
                    <Zone zoneName="LinkList2" contentId={id} />
                </GridItem>
                <GridItem {...styles.linkList3GridItem}>
                    <Zone zoneName="LinkList3" contentId={id} />
                </GridItem>
                <GridItem {...styles.subscribeGridItem}>
                    <Zone zoneName="Subscribe" contentId={id} />
                </GridItem>
            </GridContainer>
        </>
    );
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
    },
};

export default footerContainer;
